import { clientOnly } from "vike-react/clientOnly";

export const getMaterialIcon = (IconName) => {
  const IconComponent = clientOnly(async () => (await import("@mui/icons-material"))[IconName]);
  return IconComponent;
};
